module.exports = new __parcel__URL__("shop_army_button.8bea408d.png").toString();